export const applicationIdentifier = function () {
  if (process.env.REACT_APP_IS_RESELLER_APP) {
    return "reseller";
  } else if (process.env.REACT_APP_IS_ORGANIZATION_APP) {
    return "organization";
  } else {
    throw new Error("No such application");
  }
};
